import { Check, Copy, DownloadSimple, QrCode } from '@phosphor-icons/react'
import { Button } from 'antd'
import { QRCodeSVG } from 'qrcode.react'
import { useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'

import { DATE_CONSTANTS } from '@/domain/constants/date'
import Tooltip from '@/ui/atoms/Tooltip'
import cn from '@/utils/tailwind/cn'

import { copyQRCodeImage } from './utils/copyQRCodeImage'
import { downloadCanvasQRCode } from './utils/downloadCanvasQRCode'

type Props = {
  publicUrl: string
}

export const URLLinkContent = ({ publicUrl }: Props) => {
  const [openQrCode, setOpenQrCode] = useState(false)
  const [copied, setCopied] = useState(false)

  const onCopy = () => {
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, DATE_CONSTANTS.TIME_IN_MILLISECONDS.SECOND * 5)
  }
  return (
    <div className="mt-7 flex flex-col gap-2">
      <h1 className="font-medium">Share a link</h1>
      <div className="flex items-center gap-3">
        <span className="flex min-h-[42px] w-full items-center rounded border !border-gray-200 bg-gray-200/45 px-3 py-1.5 text-gray-600/90">
          <a href={publicUrl} rel="noreferrer" target="_blank">
            {publicUrl}
          </a>
        </span>
        <div className="flex items-center gap-1.5">
          <Tooltip
            mouseEnterDelay={0.3}
            title={copied ? 'Copied' : 'Copy link'}
          >
            <i>
              <CopyToClipboard {...{ onCopy, text: publicUrl }}>
                <Button
                  className={cn(
                    '!px-3 font-normal transition focus:outline-none focus-visible:outline-none',
                    {
                      'bg-green-600 text-white hover:!border-transparent hover:!bg-green-600':
                        copied,
                    }
                  )}
                >
                  {copied ? (
                    <span className="flex items-center justify-center gap-2.5">
                      <Check className="text-xl" weight="bold" />
                    </span>
                  ) : (
                    <Copy className="text-xl" weight="bold" />
                  )}
                </Button>
              </CopyToClipboard>
            </i>
          </Tooltip>
          <Tooltip
            mouseEnterDelay={0.3}
            title={openQrCode ? 'Close QR Code' : 'QR Code'}
          >
            <Button
              className={cn(
                '!px-3 font-normal transition focus:outline-none focus-visible:outline-none',
                {
                  'bg-gray-200 text-gray-900 hover:!border-transparent hover:!bg-gray-300/70 hover:!text-gray-900':
                    openQrCode,
                }
              )}
              onClick={() => setOpenQrCode((old) => !old)}
            >
              <QrCode className="text-xl" weight="bold" />
            </Button>
          </Tooltip>
        </div>
      </div>
      {openQrCode ? (
        <div
          className="mt-4 flex flex-col items-center justify-center gap-1.5 border-t border-dashed border-gray-200 pt-8"
          id="my_qrcode"
        >
          <QRCodeSVG
            bgColor="#fff"
            className="rounded-lg border !border-gray-200 p-2"
            size={206}
            value={publicUrl}
          />
          <div className="flex items-center gap-1.5">
            <Button
              className="h-9 border-gray-200/70 !px-3 text-sm transition focus:outline-none focus-visible:outline-none"
              onClick={downloadCanvasQRCode}
            >
              <DownloadSimple className="text-base" weight="bold" /> Download
            </Button>
            <Button
              className="h-9 border-gray-200/70 !px-3 text-sm transition focus:outline-none focus-visible:outline-none"
              onClick={copyQRCodeImage}
            >
              <Copy className="text-base" weight="bold" /> Copy
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  )
}
